import type { ReturnRequestStatusDto } from "@babackapp/private-api-client/types";

// status names, the most recent first
const statusRanksArray = [
	"error",
	"cancelled",
	"resolved",
	"treatedMerchant",
	"partiallyTreatedMerchant",
	"treatedLogistician",
	"partiallyTreatedLogistician",
	"shipped",
	"shipping",
	"waiting",
	"approved",
	"created",
] as const;

export default function getStatusFromReturnRequest(
	statuses: ReturnRequestStatusDto,
) {
	return (
		statusRanksArray.find((status) => {
			if (statuses && statuses[status]) {
				return statuses[status]?.done;
			}
		}) || "unknown"
	);
}
